import { StyleSheet } from "aphrodite";
import theme from "../../common/theme/mellon";

export default StyleSheet.create({
    gridDiv: {
        paddingBottom: "15px",
        '@media (max-width: 927px)': {
            justifyContent: "center",
            alignItems: "center",
        },
    },
    insideGrid: {
        '@media (max-width: 927px)': {
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
        }
    }
});
